import type { BaseRoute, ClientRoute, ClientRouteState } from '../types';

export const initialClientRouteState: ClientRouteState = {
  loading: false,
  error: undefined,
  exists: true,
};

export function createClientRoute(route: BaseRoute): ClientRoute {
  return {
    ...route,
    ...initialClientRouteState,
  };
}
